import React, { useState, useRef } from "react";
import { canCapturePhoto } from "~services/utils/deviceCapture";

const File = ({ field, values, setFieldValue, formikRef, isDisabled = false }) => {
  const [isMobile] = useState(canCapturePhoto);
  const fileInputRef = useRef(null);

  const deleteFile = (index) => {
    const currentValue = values[field.id];
    if (field.type === "foto") {
      setFieldValue(field.id, null);
    } else {
      const newValue = Array.isArray(currentValue) ? currentValue.filter((_, i) => i !== index) : [];
      setFieldValue(field.id, newValue);
    }
  };

  const handleTakePhoto = () => {
    if (!isMobile) {
      alert("A captura de foto só é permitida em dispositivos móveis.");
      return;
    }
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);

    if (files.length === 0) return;

    if (field.type === "foto") {
      const file = files[0];

      if (!file.type.startsWith("image/")) {
        alert("Por favor, tire uma foto válida.");
        event.target.value = "";
        return;
      }

      const agora = Date.now();
      if (Math.abs(agora - file.lastModified) > 10_000) {
        alert("Por favor, tire uma foto nova com a câmera, não selecione da galeria.");
        event.target.value = "";
        return;
      }

      setFieldValue(field.id, file);
    } else {
      const currentValue = values[field.id];
      const newValue = Array.isArray(currentValue) ? [...currentValue, ...files] : files;
      setFieldValue(field.id, newValue);
    }

    event.target.value = "";
  };


  const getCurrentFiles = () => {
    const value = values[field.id];
    if (field.type === "foto") {
      return value ? [value] : [];
    } else {
      return Array.isArray(value) ? value : [];
    }
  };

  const currentFiles = getCurrentFiles();


  if (field.type === "foto") {
    return (
      <div className="foto-field">
        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          capture="environment"
          onChange={handleFileChange}
          style={{ display: "none" }}
          disabled={isDisabled}
        />


        {currentFiles.length > 0 && currentFiles.map((file, index) => (
          <div key={index} className="name-file">
            <p>
              {file.name}
              <button
                type="button"
                disabled={isDisabled}
                onClick={() => deleteFile(index)}
              >
                <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
                  <path
                    d="M9.79062 0.286713C9.18125 0.428999 7.92187 0.937168 6.94687 1.40468C4.44844 2.64461 2.6 4.53499 1.36094 7.11649C0.264062 9.37275 0 10.5517 0 12.9909C0 15.4301 0.264062 16.6091 1.36094 18.8653C2.64062 21.5281 4.46875 23.3575 7.12969 24.6381C9.38437 25.7358 10.5625 26 13 26C15.4375 26 16.6156 25.7358 18.8703 24.6381C20.3937 23.9063 21.0641 23.4388 22.2422 22.2396C23.4406 21.0606 23.9078 20.3898 24.6391 18.8653C25.7359 16.6091 26 15.4301 26 12.9909C26 10.5517 25.7359 9.37275 24.6391 7.11649C23.3594 4.45369 21.5312 2.62428 18.8703 1.3437C17.8141 0.835533 16.4734 0.327366 15.8844 0.205406C14.4625 -0.0994949 11.1312 -0.0588417 9.79062 0.286713ZM11.0094 8.45805L13 10.4501L15.0312 8.4174L17.0625 6.38473L18.3219 7.66531L19.6016 8.92556L17.5703 10.9582L15.5391 12.9909L17.5703 15.0236L19.6016 17.0562L18.3219 18.3165L17.0625 19.5971L15.0312 17.5644L13 15.5317L10.9688 17.5644L8.9375 19.5971L7.67812 18.3165L6.39844 17.0562L8.42969 15.0236L10.4609 12.9909L8.42969 10.9582L6.41875 8.92556L7.61719 7.70596C8.2875 7.03518 8.87656 6.48636 8.9375 6.48636C8.97812 6.48636 9.93281 7.38073 11.0094 8.45805Z"
                    fill="#FF2E00"
                  />
                </svg>
              </button>
            </p>
          </div>
        ))}

        <button
          type="button"
          onClick={handleTakePhoto}
          disabled={isDisabled}
          className={`bg-terciaria text-white py-2 px-4 rounded hover:bg-blue-600 transition flex align-center items-center gap-2 ${
            isDisabled ? "opacity-50 cursor-not-allowed" : ""
          }`}
        >
          Tirar Foto
        <svg
          fill="#FFFFFF"
          className="w-[20px]"
          viewBox="0 0 198.931 198.931"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <g>
              <g>
                <path d="M99.469,69.561c-25.423,0-46.104,20.683-46.104,46.104s20.683,46.104,46.104,46.104 c25.421,0,46.104-20.683,46.104-46.104S124.89,69.561,99.469,69.561z M99.469,146.91c-17.229,0-31.245-14.017-31.245-31.245 c0-17.228,14.017-31.245,31.245-31.245c17.228,0,31.245,14.017,31.245,31.245C130.714,132.892,116.698,146.91,99.469,146.91z" />
                <path d="M175.499,44.681h-72.315h-3.715V27.956c0-9.393-7.64-17.036-17.033-17.036H44.247c-9.393,0-17.033,7.642-17.033,17.036 v16.726h-3.777C10.515,44.681,0,55.194,0,68.116v96.465c0,12.92,10.515,23.43,23.437,23.43h152.059 c12.925,0,23.435-10.51,23.435-23.43V68.116C198.934,55.194,188.421,44.681,175.499,44.681z M42.07,27.956 c0-1.201,0.976-2.176,2.177-2.176h38.189c1.199,0,2.174,0.976,2.174,2.177v16.726H42.07V27.956z M175.499,173.152H23.437 c-4.73,0-8.578-3.846-8.578-8.571V68.116c0-4.73,3.848-8.576,8.578-8.576h5.451H42.07h42.538h18.573h72.315 c4.73,0,8.576,3.846,8.576,8.576v96.465h0.003C184.075,169.306,180.229,173.152,175.499,173.152z" />
                <rect x="156.012" y="71.816" width="18.989" height="14.859" />
              </g>
            </g>
          </g>
        </svg>

        </button>

        {!isMobile && (
          <p className="text-sm text-red-500 mt-2">
            A captura de foto só funciona em dispositivos móveis.
          </p>
        )}
      </div>
    );
  }


  return (
    <>
      {currentFiles.length > 0 && (
        <>
          {currentFiles.map((file, index) => (
            <div key={index} className="name-file">
              <p>
                {file.name}
                <button
                  type="button"
                  disabled={isDisabled}
                  onClick={() => deleteFile(index)}
                >
                  <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
                    <path
                      d="M9.79062 0.286713C9.18125 0.428999 7.92187 0.937168 6.94687 1.40468C4.44844 2.64461 2.6 4.53499 1.36094 7.11649C0.264062 9.37275 0 10.5517 0 12.9909C0 15.4301 0.264062 16.6091 1.36094 18.8653C2.64062 21.5281 4.46875 23.3575 7.12969 24.6381C9.38437 25.7358 10.5625 26 13 26C15.4375 26 16.6156 25.7358 18.8703 24.6381C20.3937 23.9063 21.0641 23.4388 22.2422 22.2396C23.4406 21.0606 23.9078 20.3898 24.6391 18.8653C25.7359 16.6091 26 15.4301 26 12.9909C26 10.5517 25.7359 9.37275 24.6391 7.11649C23.3594 4.45369 21.5312 2.62428 18.8703 1.3437C17.8141 0.835533 16.4734 0.327366 15.8844 0.205406C14.4625 -0.0994949 11.1312 -0.0588417 9.79062 0.286713ZM11.0094 8.45805L13 10.4501L15.0312 8.4174L17.0625 6.38473L18.3219 7.66531L19.6016 8.92556L17.5703 10.9582L15.5391 12.9909L17.5703 15.0236L19.6016 17.0562L18.3219 18.3165L17.0625 19.5971L15.0312 17.5644L13 15.5317L10.9688 17.5644L8.9375 19.5971L7.67812 18.3165L6.39844 17.0562L8.42969 15.0236L10.4609 12.9909L8.42969 10.9582L6.41875 8.92556L7.61719 7.70596C8.2875 7.03518 8.87656 6.48636 8.9375 6.48636C8.97812 6.48636 9.93281 7.38073 11.0094 8.45805Z"
                      fill="#FF2E00"
                    />
                  </svg>
                </button>
              </p>
            </div>
          ))}
        </>
      )}

      <div className="click-file">
        <label htmlFor={`${field.id}`}>
          <input
            ref={fileInputRef}
            disabled={isDisabled}
            type="file"
            name={`${field.id}`}
            id={`${field.id}`}
            multiple={field.multiple}
            onChange={handleFileChange}
            className="hidden"
          />
        </label>
        <button
          disabled={isDisabled}
          type="button"
          onClick={() => document.getElementById(`${field.id}`).click()}
          className="bg-terciaria text-white py-2 px-4 rounded hover:bg-blue-600 transition flex align-center items-center gap-2"
        >
          Carregar Documentos
          <svg width="25" height="17" viewBox="0 0 25 17" fill="none">
            <path
              d="M10.4493 0.161587C8.58702 0.610723 6.53852 2.14436 5.76075 3.66704C5.60739 3.96282 5.47593 4.02854 4.67625 4.24763C2.38675 4.85013 0.623068 6.67954 0.152022 8.91427C-0.0451598 9.87827 -0.0561143 10.4698 0.152022 11.4229C0.623068 13.6247 2.18957 15.3775 4.28189 16.0347L5.1473 16.3086H12.7388C20.0455 16.3086 20.3632 16.2976 21.0533 16.0895C24.6902 14.9612 25.8076 10.4041 23.1128 7.6545C22.4117 6.94245 21.612 6.48236 20.6042 6.23041L19.914 6.06609L19.6183 5.17877C18.7638 2.65922 16.6934 0.764087 14.0862 0.150631C13.2318 -0.0575047 11.3147 -0.0465508 10.4493 0.161587ZM15.8718 9.16623L14.3382 9.19909V11.2147V13.2413H12.3116H10.285V11.2147V9.18814H8.72943H7.16293L9.73725 6.61382L12.3116 4.0395L14.864 6.58095L17.4054 9.13336L15.8718 9.16623Z"
              fill="white"
            />
          </svg>
        </button>
        <span className="ml-2 flex gap-x-1 flex-wrap ">
          {field.options?.map((option, index) => (
            <p className="text-[#75767A]" key={index}>
              {option}
            </p>
          ))}
        </span>
      </div>
    </>
  );
};

export default File;